import React from "react";
import { ChatDSFileType, ReportActions, TChartTemplate } from "../type";
import { Bubble } from 'tea-component';
import defaultCopyIcon from '@/pages/aigc/assets/svg/agent-ds-copy.svg';
import defaultExportIcon from '@/pages/aigc/assets/svg/agent-ds-export.svg';
import defaultSaveIcon from '@/pages/aigc/assets/svg/agent-ds-save.svg';
import defaultRefreshIcon from '@/pages/aigc/assets/svg/agent-ds-refresh.svg';
import copySuccessIcon from '@/pages/aigc/assets/svg/agent-copy-success.svg';
import classNames from 'classnames';
export const CHAT_DS_TEMPLATE_ACTIONS = [
  {
    label: '分析思路',
    value: ChatDSFileType.Framwork,
    labelEn: 'Framwork',
  },
  {
    label: '分析报告',
    value: ChatDSFileType.Report,
    labelEn: 'Report',
  },
];

/** ChatDSTemplate 支持的模板枚举 */
export enum ChatTemplate {
  DsReport = 'dsReport',
  AiExcel = 'aiExcel',
  MagicPoster = 'magicPoster',
  Skill = 'skill',
  SplitView = 'splitView',
}

/** ChatDSTemplate 支持的所有模板类型 */
export const CHAT_DS_TEMPLATES: TChartTemplate[] = Object.values(ChatTemplate);

// 导出类型
export enum ChatDSFileTypeExport {
  PDF = 'pdf',
  TXT = 'txt',
  Word = 'word',
}
// 导出类型
export const CHAT_DS_TEMPLATE_FILE_Type = [
  { label: 'PDF', value: ChatDSFileTypeExport.PDF, labelEn: 'PDF' },
  // TXT
  { label: 'TXT', value: ChatDSFileTypeExport.TXT, labelEn: 'TXT' },
  // Word
  { label: 'Word', value: ChatDSFileTypeExport.Word, labelEn: 'Word' }
];

export const CHAT_DS_TEMPLATE_ACTIONS_LIST = (isEn: boolean, streamingState: string, copyStatus = false) => [
  {
    label: (
      <div className="dba-chat-ds-report-page-right-resent">
        <img src={defaultRefreshIcon} alt="" />
        {isEn ? 'Reset' : '重置'}
      </div>
    ),
    value: ChatDSFileType.Report,
    key: ReportActions.ReportReset,
  },
  {
    label: (
      <Bubble
        visible={copyStatus}
        // overlayClassName='dba-nav-menu-overlay'
        content={ <div className="dba-feedback-operation-copy-contenet">
          <img src={copySuccessIcon} alt="" style={{ width: 16, height: 16, marginRight: 5 }} /> {isEn ? 'Copy succeeded' : '复制成功'}
        </div>}
      >
        <div className="dba-chat-ds-report-page-right-resent">
          <img src={defaultCopyIcon} alt="" />
          {isEn ? 'Copy' : '复制'}
        </div>
      </Bubble>
    ),
    value: ChatDSFileType.Report,
    key: ReportActions.ReportCopy,
  },
  {
    label: (
      <div className="dba-chat-ds-report-page-right-resent">
        <img src={defaultExportIcon} alt="" />
        {isEn ? 'Export' : '导出'}
      </div>
    ),
    value: ChatDSFileType.Report,
    key: ReportActions.ReportExport,
  },
  {
    label: (
      <div className="dba-chat-ds-report-page-right-resent dba-chat-ds-report-page-right-sent">
        <img src={defaultSaveIcon} alt="" />
        {isEn ? 'Save' : '保存'}
      </div>
    ),
    value: ChatDSFileType.Report,
    key: ReportActions.ReportSave,
  },
  {
    label: (
      <div className="dba-chat-ds-report-page-right-resent">
        <img src={defaultRefreshIcon} alt="" />
        {isEn ? 'Reset' : '重置'}
      </div>
    ),
    value: ChatDSFileType.Framwork,
    key: ReportActions.ImplementReset,
  },
  {
    label: (
      <div 
        className={classNames(
          "dba-chat-ds-report-page-right-sent dba-chat-ds-report-page-right-resent",
          {
            'dba-chat-ds-report-page-right-disabled':
              (streamingState && (streamingState !== 'complete')),
          },
        )}
      >
        {isEn ? 'Generate Report' : '生成分析报告'}
      </div>
    ),
    value: ChatDSFileType.Framwork,
    key: ReportActions.ImplementGenerate,
  },
];

// 左侧QA拖拽容器的宽度常量
export const MIN_QA_CONTAINER_WIDTH = 475; // 最小宽度
export const MAX_QA_CONTAINER_WIDTH = 700; // 最大宽度
// DS报告
export const INITIAL_QA_CONTAINER_WIDTH = 475; // 初始宽度
// 魔法海报  初始宽度
export const INITIAL_MAGIC_POSTER_CONTAINER_WIDTH = 520;
// AI表格 初始宽度
export const INITIAL_AI_TABLE_CONTAINER_WIDTH = 530;

// template -> initialWidth mapping
export const TEMPLATE_INITIAL_WIDTH_MAP: Record<string, number> = {
  dsReport: INITIAL_QA_CONTAINER_WIDTH,
  aiExcel: INITIAL_AI_TABLE_CONTAINER_WIDTH,
  magicPoster: INITIAL_MAGIC_POSTER_CONTAINER_WIDTH,
};

// template -> minWidth mapping，智能表格最小宽度与初始宽度一致
export const TEMPLATE_MIN_WIDTH_MAP: Record<string, number> = {
  dsReport: MIN_QA_CONTAINER_WIDTH,
  aiExcel: INITIAL_AI_TABLE_CONTAINER_WIDTH,
  magicPoster: INITIAL_MAGIC_POSTER_CONTAINER_WIDTH,
};

// Default input box height offset
export const DEFAULT_INPUT_BOX_OFFSET = 200;

// componentType -> input box height offset mapping
export const TEMPLATE_INPUT_BOX_OFFSET_MAP: Record<string, number> = {
  smart_table: 100,
  document: 200,
  magic_poster: 200,
  ai_gallery_file: 200,
};